import { useContext, useEffect } from 'react';
import { UrlContext } from './Context/UrlContext';

const AutoCreateAdmin = () => {

   const { apiBaseUrl } = useContext(UrlContext);

  useEffect(() => {
    const checkAndCreateAdmin = async () => {
      try {
        const res = await fetch(`${apiBaseUrl}/admins/exists`);
        const data = await res.json();

        if (!data.exists) {
          // No admin found, create default admin
          await fetch(`${apiBaseUrl}/register-admin`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name: 'Admin',
              email: 'admin@gmail.com',
              password: 'Admin1234',
              role: 'admin'
            })
          });

          console.log('Default admin created');
        }
      } catch (err) {
        console.error('Error checking/creating admin:', err);
      }
    };

    checkAndCreateAdmin();
  }, [apiBaseUrl]);

  return null; // This component doesn't render anything
};

export default AutoCreateAdmin;
